import { useRef, useState } from "react";
import { IconButton, Tooltip, Snackbar, Alert } from "@mui/material";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CopyAllOutlinedIcon from '@mui/icons-material/CopyAllOutlined';
import MuiBlock from "./MuiCustoms";
import LuckyNumberFormatUtil from "../helpers/LuckyNumberFormatUtil";
import StringToKebab from "../helpers/StringToKebab";

export const LuckyNumberDownload = ({promoName, listOfNumbers}) => {
    const link = useRef(null);

    const getCurrentDateString = () => {
        let dt = new Date();
        const offset = dt.getTimezoneOffset();
        
        dt = new Date(dt.getTime() - (offset * 60 * 1000))
        return dt.toISOString().split('T')[0]
    }

    const downloadNumbersList = () => {
        let tableRows = '';
        listOfNumbers.forEach((item,index) => {
            tableRows += `
                <tr style="">
                    <td align="center" style="border: 1px solid #ccc; ${item.isWinner ? "background: #E0FFF3" : (index % 2 === 0 ? "background: #f1f1f1" : "")}">${promoName}</td>
                    <td align="center" style="border: 1px solid #ccc; ${item.isWinner ? "background: #E0FFF3" : (index % 2 === 0 ? "background: #f1f1f1" : "")}">'${LuckyNumberFormatUtil(item.luckyNumber)}'</td>
                    <td align="center" style="border: 1px solid #ccc; ${item.isWinner ? "background: #E0FFF3" : (index % 2 === 0 ? "background: #f1f1f1" : "")}">${item.isWinner ? 'Sim' : 'Não'}</td>
                </tr>   
            `;
        });

        const textToSave = `
            <table style="border: 1px solid #ccc; border-collapse: collapse;">
                <thead>
                    <tr>
                        <th width="200" style="font-size: 14pt; border-bottom: 1px solid #000;">Promoção</th>
                        <th width="150" style="font-size: 14pt; border-bottom: 1px solid #000;">Número da sorte</th>
                        <th width="100" style="font-size: 14pt; border-bottom: 1px solid #000;">Premiado?</th>
                    </tr>
                </thead>
                <tbody>
                    ${tableRows}
                </tbody>
                <tfooter>
                    <tr>
                        <td colspan="3"></td>
                    </tr>
                </tfooter>
            </table>
        `;
        const textFileAsBlob = new Blob([textToSave], {type:'data:application/vnd.ms-excel;base64'});
        const textFileUrl = window.URL.createObjectURL(textFileAsBlob);
        link.current.setAttribute('download',`meus-numeros--${StringToKebab(promoName)}--${getCurrentDateString()}.xls`);
        link.current.href = textFileUrl;
        link.current.click();
        // window.open( textFileUrl,'_blank');
    }

    return (
        <MuiBlock style={{position: "relative", textAlign: "center", overflow: "hidden"}}>
            <Tooltip title="Baixar lista de números em XLS (Excel)">
                <IconButton color="primary" onClick={downloadNumbersList}>
                    <FileDownloadOutlinedIcon />
                </IconButton>
            </Tooltip>
            <a href="void" target="_blank" ref={link} style={{position: "absolute", left: "-10000px"}}>link</a>
        </MuiBlock>
    )
}

export const LuckyNumberCopyToClipboard = ({listOfNumbers}) => {
    const textArea = useRef(null);

    const [copySuccess, setCopySuccess] = useState(false);

    const copyToClipboard = async () => {
         try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(listOfNumbers);
                setCopySuccess(true);
            } else {
                // Fallback for older browsers if needed
                copyToClipboardFallback(); 
            }
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    }

    const copyToClipboardFallback = () => {
        textArea.current.select();
        textArea.current.setSelectionRange(0, 9999999); // For mobile devices

        try {
            document.execCommand('copy');
            setCopySuccess(true);
        } catch (err) {
            console.error('Failed to copy text using execCommand: ', err);
        } 
    }

    return (
        <>
        <MuiBlock style={{position: "relative", textAlign: "center", overflow: "hidden"}}>
            <Tooltip title="Copiar números para a área de trabalho">
                <IconButton color="primary" onClick={copyToClipboard}>
                    <CopyAllOutlinedIcon />
                </IconButton>
            </Tooltip>
            <textarea ref={textArea} rows="10" cols="50" style={{position: "absolute", left: "-10000px"}} defaultValue={listOfNumbers} />
        </MuiBlock>
        <Snackbar open={copySuccess} autoHideDuration={6000} onClose={() => setCopySuccess(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Alert onClose={() => setCopySuccess(false)} severity="success">
                Números copiados!
            </Alert>
        </Snackbar>
        </>
    )
}